import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";

function ListadoDocumentosSoporte() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [cuentasPorPagar, setCuentasPorPagar] = useState([]);
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [usuarioFiltro, setUsuarioFiltro] = useState('');
    const [busquedaProveedor, setBusquedaProveedor] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [sedeFiltro, setSedeFiltro] = useState('');
    const [sedes, setSedes] = useState([]);
    
    // Selección de documentos
    const [documentoSeleccionadoId, setDocumentoSeleccionadoId] = useState(null);
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;
    
    // Modal Debug
    const [showModalDebug, setShowModalDebug] = useState(false);
    const [debugData, setDebugData] = useState(null);
    const [debugType, setDebugType] = useState('');
    
    // Modal Abono
    const [showModalAbono, setShowModalAbono] = useState(false);
    const [documentoAbono, setDocumentoAbono] = useState(null);
    const [valorAbono, setValorAbono] = useState('');
    const [observacionesAbono, setObservacionesAbono] = useState('');
    
    // Modal Anulación
    const [showModalAnulacion, setShowModalAnulacion] = useState(false);
    const [documentoAnular, setDocumentoAnular] = useState(null);
    const [prefijoAnulacion, setPrefijoAnulacion] = useState('');
    const [motivoAnulacion, setMotivoAnulacion] = useState('');
    const [fechaAnulacion, setFechaAnulacion] = useState(new Date().toISOString().split('T')[0]);
    const [prefijosNota, setPrefijosNota] = useState([]);

    useEffect(() => {
        const hoy = new Date();
        const inicioSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay()));
        const finSemana = new Date(hoy.setDate(hoy.getDate() - hoy.getDay() + 6));
        
        setFechaInicio(inicioSemana.toISOString().split('T')[0]);
        setFechaFin(finSemana.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a ver listado de documentos soporte
        const tienePermiso = userdata.up && userdata.up.includes('ver_listado_documentos_soporte');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        // ✅ Ya NO necesitas config - el interceptor agrega el token
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setProveedores(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/sedes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setSedes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar cuentas por pagar para mostrar saldos
        cargarCuentasPorPagar();
    }, []);

    const cargarCuentasPorPagar = () => {
        axios.get('/cuentas-por-pagar')
            .then(response => {
                if (response.status === 200) {
                    setCuentasPorPagar(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar cuentas por pagar: ' + error);
            });
    };

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarDocumentos();
        }
    }, [loggedIn, fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro]);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            const timeoutId = setTimeout(() => {
                cargarDocumentos();
            }, 500);
            return () => clearTimeout(timeoutId);
        }
    }, [busquedaProveedor]);

    const cargarDocumentos = () => {
        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // ✅ Ya NO necesitas crear config con Authorization

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (usuarioFiltro) params.append('usuario_id', usuarioFiltro);
        if (busquedaProveedor) params.append('busqueda_proveedor', busquedaProveedor);
        if (estadoFiltro !== '') params.append('estado', estadoFiltro);
        if (sedeFiltro) params.append('sede_id', sedeFiltro);

        // ✅ El interceptor agrega el token automáticamente
        axios.get('/documentos-soporte?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setDocumentos(response.data);
                    // Recargar cuentas por pagar cuando se actualizan los documentos
                    cargarCuentasPorPagar();
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const getNombreProveedor = (proveedorId) => {
        const proveedor = proveedores.find(p => p.id === proveedorId);
        return proveedor ? proveedor.nombre_proveedor : 'N/A';
    };

    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id === usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const getSaldoPendiente = (documentoId) => {
        const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documentoId);
        return cuenta ? parseFloat(cuenta.valor_pendiente || 0) : 0;
    };

    const getTipoPagoTexto = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'Pagada';
            case 'por_pagar': return 'Por Pagar';
            default: return 'Pagada'; // Default para documentos antiguos
        }
    };

    const getTipoPagoColor = (tipoPago) => {
        switch(tipoPago) {
            case 'pagada': return 'badge badge-outline-success';
            case 'por_pagar': return 'badge badge-outline-warning';
            default: return 'badge badge-success';
        }
    };

    const getEstadoTexto = (estado) => {
        switch(estado) {
            case 0: return 'Generado';
            case 1: return 'Enviado DIAN';
            case 2: return 'Anulado';
            case 3: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch(estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-danger';
            case 3: return 'badge badge-outline-danger';
            default: return 'badge badge-outline-secondary';
        }
    };

    const abrirModalAbono = (documento) => {
        const saldoPendiente = getSaldoPendiente(documento.id);
        
        if (saldoPendiente <= 0) {
            alert('Este documento no tiene saldo pendiente por pagar.');
            return;
        }

        setDocumentoAbono(documento);
        setValorAbono('');
        setObservacionesAbono('');
        setShowModalAbono(true);
    };

    const realizarAbono = async () => {
        if (!valorAbono || parseFloat(valorAbono) <= 0) {
            alert('Por favor ingrese un valor válido para el abono.');
            return;
        }

        const saldoPendiente = getSaldoPendiente(documentoAbono.id);
        const montoAbono = parseFloat(valorAbono);

        if (montoAbono > saldoPendiente) {
            alert(`El abono no puede ser mayor al saldo pendiente ($${saldoPendiente.toLocaleString('es-CO')})`);
            return;
        }

        if (!window.confirm(`¿Está seguro de realizar un abono de $${montoAbono.toLocaleString('es-CO')}?`)) {
            return;
        }

        try {
            // Buscar la cuenta por pagar correspondiente
            const cuenta = cuentasPorPagar.find(c => c.documento_soporte_id === documentoAbono.id);
            
            if (!cuenta) {
                alert('No se encontró la cuenta por pagar para este documento.');
                return;
            }

            const response = await axios.post(`/cuenta-por-pagar/${cuenta.id}/abono`, {
                valor_abono: montoAbono,
                observaciones: observacionesAbono
            });
            
            if (response.status === 200 || response.status === 201) {
                const mensaje = response.data.estado === 'Pagada' 
                    ? `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nDocumento COMPLETAMENTE PAGADO.\nEgreso N° ${response.data.numero_egreso} generado.`
                    : `Abono de $${montoAbono.toLocaleString('es-CO')} realizado exitosamente.\nSaldo pendiente: $${response.data.saldo_pendiente.toLocaleString('es-CO')}\nEgreso N° ${response.data.numero_egreso} generado.`;
                
                alert(mensaje);
                setShowModalAbono(false);
                cargarDocumentos();
                cargarCuentasPorPagar();
                setDocumentoSeleccionadoId(null);
            }
        } catch (error) {
            console.error('Error al realizar abono:', error);
            alert('Error al realizar abono: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirModalAnulacion = async (documento) => {
        setDocumentoAnular(documento);
        
        // Si es borrador (estado 0), anular directamente sin modal
        if (documento.estado === 0) {
            if (!window.confirm('¿Está seguro de anular este documento soporte en borrador?')) {
                return;
            }
            
            // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
            try {
                const response = await axios.post('/nota-documento-soporte', {
                    documento_soporte_id: documento.id
                });
                
                if (response.status === 200 || response.status === 201) {
                    alert('Documento soporte anulado exitosamente (borrador)');
                    cargarDocumentos();
                }
            } catch (error) {
                alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
            }
            return;
        }
        
        // Si está enviado a DIAN (estado 1), cargar prefijos y mostrar modal
        if (documento.estado === 1) {
            let userdata = JSON.parse(localStorage.getItem('userdata'));
            // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente

            try {
                const response = await axios.get('/parametros-fev?uid=' + userdata.user_id);
                if (response.status === 200) {
                    const prefijosFiltrados = response.data.filter(p => 
                        p.tipo === 'Nota Documento Soporte' && 
                        p.estado == 1
                    );
                    setPrefijosNota(prefijosFiltrados);
                    setShowModalAnulacion(true);
                }
            } catch (error) {
                alert('Error al cargar prefijos: ' + error.message);
            }
        } else {
            alert('Solo se pueden anular documentos en estado Borrador o Enviado a DIAN');
        }
    };

    const generarNotaAnulacion = async () => {
        if (!prefijoAnulacion) {
            alert('Por favor seleccione un prefijo');
            return;
        }

        if (!fechaAnulacion) {
            alert('Por favor seleccione una fecha');
            return;
        }

        if (!window.confirm('¿Está seguro de generar una Nota de Documento Soporte para anular? Esta acción no se puede deshacer.')) {
            return;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        try {
            // Enviar directamente a DIAN (sin crear nota primero)
            const envioResponse = await axios.post('/nota-documento-soporte/enviar-dian-directo', {
                documento_soporte_id: documentoAnular.id,
                parametrosfev_id: parseInt(prefijoAnulacion),
                motivo_observacion: motivoAnulacion || 'Anulación de documento soporte',
                fecha_emision: fechaAnulacion
            });
            
            setShowModalAnulacion(false);
            
            if (envioResponse.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Nota de documento soporte enviada exitosamente a la DIAN',
                    cufe: envioResponse.data.uuid
                });
                setShowModalDebug(true);
            } else {
                setDebugType('error');
                setDebugData({
                    message: envioResponse.data.message,
                    response: envioResponse.data.response,
                    json_enviado: envioResponse.data.json_enviado,
                    status_code: envioResponse.data.status_code
                });
                setShowModalDebug(true);
            }
            
            cargarDocumentos();
            setPrefijoAnulacion('');
            setMotivoAnulacion('');
            setFechaAnulacion(new Date().toISOString().split('T')[0]);
            
        } catch (error) {
            console.error('Error al enviar nota a DIAN:', error);
            setShowModalAnulacion(false);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data
            });
            setShowModalDebug(true);
        }
    };

    const anulacionProvisional = async (documentoId) => {
        if (!window.confirm('¿Está seguro de anular provisionalmente este documento?\n\nEsta acción cambiará el estado a ANULADO sin enviar nada a la DIAN.')) {
            return;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        try {
            const response = await axios.post(`/documento-soporte/${documentoId}/anulacion-provisional`, {});
            
            if (response.status === 200) {
                alert('Documento anulado provisionalmente');
                cargarDocumentos();
                setDocumentoSeleccionadoId(null);
            }
        } catch (error) {
            console.error('Error al anular:', error);
            alert('Error al anular el documento: ' + (error.response?.data?.message || error.message));
        }
    };

    const enviarDian = async (documentoId) => {
        if (!window.confirm('¿Está seguro de enviar este documento a la DIAN?')) {
            return;
        }

        // ✅ Ya NO necesitas config - el interceptor agrega el token automáticamente
        try {
            const response = await axios.post(`/documento-soporte/${documentoId}/enviar-dian`, {});
            
            if (response.data.success) {
                setDebugType('success');
                setDebugData({
                    message: 'Documento soporte enviado exitosamente a la DIAN',
                    cufe: response.data.uuid,
                    estado: response.data.estado,
                    documentoId: documentoId
                });
                setShowModalDebug(true);
                cargarDocumentos();
            } else {
                setDebugType('error');
                setDebugData({
                    message: response.data.message,
                    response: response.data.response,
                    json_enviado: response.data.json_enviado,
                    status_code: response.data.status_code,
                    documentoId: documentoId
                });
                setShowModalDebug(true);
            }
        } catch (error) {
            console.error('Error al enviar a DIAN:', error);
            
            setDebugType('error');
            setDebugData({
                message: error.response?.data?.message || error.message,
                error: error.response?.data?.error,
                response: error.response?.data?.response,
                json_enviado: error.response?.data?.json_enviado,
                fullError: error.response?.data,
                documentoId: documentoId
            });
            setShowModalDebug(true);
        }
    };

    const generarEgresoDesdeListado = async (documentoId) => {
        if (!window.confirm('¿Está seguro de generar un egreso para cancelar esta cuenta por pagar?')) {
            return;
        }

        try {
            const response = await axios.post('/documento-soporte/generar-egreso', {
                documento_soporte_id: documentoId
            });
            
            if (response.status === 200 || response.status === 201) {
                alert(`Egreso N° ${response.data.numero_egreso} generado exitosamente.\nDocumento marcado como PAGADA.`);
                cargarDocumentos(); // Recargar la lista
                setDocumentoSeleccionadoId(null); // Deseleccionar
            }
        } catch (error) {
            console.error('Error al generar egreso:', error);
            alert('Error al generar egreso: ' + (error.response?.data?.message || error.message));
        }
    };

    const getDocumentoSeleccionado = () => {
        return documentos.find(d => d.id === documentoSeleccionadoId);
    };

    const handleSeleccionDocumento = (documentoId) => {
        setDocumentoSeleccionadoId(documentoSeleccionadoId === documentoId ? null : documentoId);
    };

    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const documentosPaginados = documentos.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(documentos.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setDocumentoSeleccionadoId(null);
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, usuarioFiltro, estadoFiltro, sedeFiltro, busquedaProveedor]);

    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <style>{`
                    .table-info {
                        background-color: #f6fcfd !important;
                        border-left: 4px solid #17a2b8;
                    }
                    .table tbody tr:hover {
                        background-color: #f6fcfd;
                        transform: scale(1.001);
                        transition: all 0.2s ease;
                    }
                    .badge-lg {
                        font-size: 0.85em;
                        padding: 0.5em 0.75em;
                    }
                    .table tbody tr.table-info:hover {
                        background-color: #e6f7f9 !important;
                        box-shadow: 0 2px 4px rgba(23, 162, 184, 0.15);
                    }
                    .card-header.bg-gradient-light {
                        background: linear-gradient(135deg, #f6fcfd 0%, #e6f7f9 100%);
                        border-bottom: 2px solid #17a2b8;
                    }
                    .shadow-sm {
                        box-shadow: 0 0.125rem 0.25rem rgba(23, 162, 184, 0.1) !important;
                    }
                    .table th {
                        background-color: #323a45;
                        color: #f6fcfd;
                        border-top: none;
                        font-weight: 600;
                        font-size: 0.9rem;
                        vertical-align: middle;
                    }
                    .table td {
                        vertical-align: middle;
                        font-size: 0.9rem;
                    }
                    .card-primary.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .card-info.card-outline {
                        border-top: 3px solid #17a2b8;
                    }
                    .pagination .page-item.active .page-link {
                        background-color: #323a45;
                        border-color: #323a45;
                        color: #f6fcfd;
                    }
                    .pagination .page-link {
                        color: #323a45;
                        border-color: #dee2e6;
                    }
                    .pagination .page-link:hover {
                        background-color: #f6fcfd;
                        border-color: #17a2b8;
                        color: #323a45;
                    }
                    .pagination .page-item.disabled .page-link {
                        color: #6c757d;
                        background-color: #fff;
                        border-color: #dee2e6;
                    }
                    .badge-outline {
                        background-color: transparent;
                        border-width: 1px;
                        border-style: solid;
                    }
                    .badge-outline-secondary {
                        color: #6c757d;
                        border: 1px solid #6c757d;
                        background-color: transparent;
                    }
                    .badge-outline-success {
                        color: #28a745;
                        border: 1px solid #28a745;
                        background-color: transparent;
                    }
                    .badge-outline-danger {
                        color: #dc3545;
                        border: 1px solid #dc3545;
                        background-color: transparent;
                    }
                    .badge-outline-warning {
                        color: #ffc107;
                        border: 1px solid #ffc107;
                        background-color: transparent;
                    }
                    .badge-outline-info {
                        color: #17a2b8;
                        border-color: #17a2b8;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item active">Listado de Documentos Soporte</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Listado de Documentos Soporte</h1>
                                </div>
                                <div className="col-sm-4">
                                    <Link to="/crear-documento-soporte" className="btn btn-primary float-right">
                                        <i className="fas fa-plus"></i> Nuevo Documento Soporte
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            {/* Filtros */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Filtros</b></h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Usuario</label>
                                                <select 
                                                    className="form-control" 
                                                    value={usuarioFiltro}
                                                    onChange={(e) => setUsuarioFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>{usuario.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Estado</label>
                                                <select 
                                                    className="form-control" 
                                                    value={estadoFiltro}
                                                    onChange={(e) => setEstadoFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    <option value="0">Generado</option>
                                                    <option value="1">Enviado DIAN</option>
                                                    <option value="2">Anulado</option>
                                                    <option value="3">Error DIAN</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Sede</label>
                                                <select 
                                                    className="form-control" 
                                                    value={sedeFiltro}
                                                    onChange={(e) => setSedeFiltro(e.target.value)}
                                                >
                                                    <option value="">Todas</option>
                                                    {sedes.map(sede => (
                                                        <option key={sede.id} value={sede.id}>{sede.nombre}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Buscar Proveedor</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Nombre del proveedor..."
                                                    value={busquedaProveedor}
                                                    onChange={(e) => setBusquedaProveedor(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Barra de acciones */}
                            {documentoSeleccionadoId && (
                                <div className="card card-primary card-outline shadow-sm">
                                    <div className="card-header bg-gradient-light">
                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <div className="d-flex align-items-center flex-wrap">
                                                <h5 className="mb-0 mr-3">
                                                    <i className="fas fa-check-circle text-success"></i> 
                                                    <strong>Documento N° {getDocumentoSeleccionado()?.prefijo}-{getDocumentoSeleccionado()?.numero}</strong>
                                                </h5>
                                                <div className="d-flex flex-wrap">
                                                    <span className="mr-2 mb-1">
                                                        <span className={`badge badge-lg ${getEstadoColor(getDocumentoSeleccionado()?.estado)}`}>
                                                            {getEstadoTexto(getDocumentoSeleccionado()?.estado)}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <button 
                                                className="btn btn-sm btn-outline-secondary mt-2 mt-md-0"
                                                onClick={() => setDocumentoSeleccionadoId(null)}
                                            >
                                                <i className="fas fa-times"></i> Deseleccionar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body py-3">
                                        <div className="btn-toolbar" role="toolbar">
                                            {/* Botón Información - Disponible para todos los estados */}
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <Link
                                                    to={`/informacion-documento-soporte/${documentoSeleccionadoId}`}
                                                    className="btn btn-info"
                                                    title="Ver Información Completa"
                                                >
                                                    <i className="fas fa-info-circle"></i> Información
                                                </Link>
                                            </div>

                                            {/* Botón Generar Egreso - Para documentos por pagar (cualquier estado DIAN) */}
                                            {getDocumentoSeleccionado()?.tipo_pago === 'por_pagar' && getSaldoPendiente(documentoSeleccionadoId) > 0 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-primary"
                                                            onClick={() => abrirModalAbono(getDocumentoSeleccionado())}
                                                            title="Realizar Abono Parcial"
                                                        >
                                                            <i className="fas fa-coins"></i> Realizar Abono
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-primary"
                                                            onClick={() => generarEgresoDesdeListado(documentoSeleccionadoId)}
                                                            title="Pagar Saldo Completo"
                                                        >
                                                            <i className="fas fa-money-bill-wave"></i> Pagar Todo
                                                        </button>
                                                    </div>
                                                </>
                                            )}

                                            {/* Estado 0: Generado - Anular, Anulación Provisional, Enviar DIAN */}
                                            {getDocumentoSeleccionado()?.estado === 0 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => abrirModalAnulacion(getDocumentoSeleccionado())}
                                                            title="Anular Documento"
                                                        >
                                                            <i className="fas fa-ban"></i> Anular
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => anulacionProvisional(documentoSeleccionadoId)}
                                                            title="Anulación Provisional (sin DIAN)"
                                                        >
                                                            <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-primary"
                                                            onClick={() => enviarDian(documentoSeleccionadoId)}
                                                            title="Enviar a la DIAN"
                                                        >
                                                            <i className="fas fa-paper-plane"></i> Enviar a DIAN
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                            
                                            {/* Estado 1: Enviado DIAN - Anular con Nota, Anulación Provisional */}
                                            {getDocumentoSeleccionado()?.estado === 1 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => abrirModalAnulacion(getDocumentoSeleccionado())}
                                                            title="Generar Nota de Anulación"
                                                        >
                                                            <i className="fas fa-file-invoice"></i> Nota Anulación
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => anulacionProvisional(documentoSeleccionadoId)}
                                                            title="Anulación Provisional (sin DIAN)"
                                                        >
                                                            <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                            
                                            {/* Estado 3: Error DIAN - Anular, Anulación Provisional, Enviar DIAN */}
                                            {getDocumentoSeleccionado()?.estado === 3 && (
                                                <>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => abrirModalAnulacion(getDocumentoSeleccionado())}
                                                            title="Anular Documento"
                                                        >
                                                            <i className="fas fa-ban"></i> Anular
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-outline-danger"
                                                            onClick={() => anulacionProvisional(documentoSeleccionadoId)}
                                                            title="Anulación Provisional (sin DIAN)"
                                                        >
                                                            <i className="fas fa-exclamation-triangle"></i> Anulación Provisional
                                                        </button>
                                                    </div>
                                                    <div className="btn-group mr-2 mb-2" role="group">
                                                        <button 
                                                            className="btn btn-primary"
                                                            onClick={() => enviarDian(documentoSeleccionadoId)}
                                                            title="Reintentar envío a la DIAN"
                                                        >
                                                            <i className="fas fa-redo"></i> Enviar a DIAN
                                                        </button>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tabla de documentos */}
                            <div className="card card-info card-outline">
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-hover" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th width="50">Seleccionar</th>
                                                <th>N° Documento</th>
                                                <th>Fecha</th>
                                                <th>Proveedor</th>
                                                <th>Usuario</th>
                                                <th>Total</th>
                                                <th>Saldo Pendiente</th>
                                                <th>Estado Pago</th>
                                                <th>Estado DIAN</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {documentosPaginados.map(documento => (
                                                <tr 
                                                    key={documento.id} 
                                                    className={documentoSeleccionadoId === documento.id ? 'table-info' : ''}
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => handleSeleccionDocumento(documento.id)}
                                                >
                                                    <td className="text-center">
                                                        <input 
                                                            type="radio" 
                                                            name="documentoSeleccionado"
                                                            checked={documentoSeleccionadoId === documento.id}
                                                            onChange={() => handleSeleccionDocumento(documento.id)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </td>
                                                    <td>
                                                        <strong>{documento.prefijo}-{documento.numero}</strong>
                                                    </td>
                                                    <td>{new Date(documento.fecha_emision).toLocaleDateString()}</td>
                                                    <td>
                                                        <span title={getNombreProveedor(documento.proveedor_id)}>
                                                            {getNombreProveedor(documento.proveedor_id).length > 25 
                                                                ? getNombreProveedor(documento.proveedor_id).substring(0, 25) + '...' 
                                                                : getNombreProveedor(documento.proveedor_id)
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>{getNombreUsuario(documento.users_id)}</td>
                                                    <td className="text-right">
                                                        <strong>${Math.round(parseFloat(documento.valor_total)).toLocaleString('es-CO')}</strong>
                                                    </td>
                                                    <td className="text-right">
                                                        {documento.tipo_pago === 'por_pagar' ? (
                                                            <span className="text-danger">
                                                                <strong>${Math.round(getSaldoPendiente(documento.id)).toLocaleString('es-CO')}</strong>
                                                            </span>
                                                        ) : (
                                                            <span className="text-success">
                                                                <strong>$0</strong>
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={getTipoPagoColor(documento.tipo_pago || 'pagada')}>
                                                            {getTipoPagoTexto(documento.tipo_pago || 'pagada')}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className={`badge ${getEstadoColor(documento.estado)}`}>
                                                            {getEstadoTexto(documento.estado)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {documentos.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron documentos soporte para los filtros seleccionados.</p>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Paginador */}
                                {documentos.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistro + 1} a {Math.min(indiceUltimoRegistro, documentos.length)} de {documentos.length} registros
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual - 1)}
                                                            disabled={paginaActual === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>
                                                    
                                                    {[...Array(totalPaginas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginas ||
                                                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                                                        ) {
                                                            return (
                                                                <li 
                                                                    key={numeroPagina} 
                                                                    className={`page-item ${paginaActual === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => cambiarPagina(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActual - 2 ||
                                                            numeroPagina === paginaActual + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}
                                                    
                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual + 1)}
                                                            disabled={paginaActual === totalPaginas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal Anulación */}
                {showModalAnulacion && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header bg-danger text-white">
                                    <h4 className="modal-title">Anular Documento Soporte</h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalAnulacion(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-warning">
                                        <i className="fas fa-exclamation-triangle"></i> Esta acción generará una Nota de Documento Soporte y anulará el documento original.
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Documento a Anular</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={documentoAnular ? `${documentoAnular.prefijo}${documentoAnular.numero}` : ''}
                                            readOnly
                                        />
                                    </div>
                                    
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Prefijo Nota *</label>
                                                <select 
                                                    className="form-control" 
                                                    value={prefijoAnulacion}
                                                    onChange={(e) => setPrefijoAnulacion(e.target.value)}
                                                    required
                                                >
                                                    <option value="">Seleccionar...</option>
                                                    {prefijosNota.map(p => (
                                                        <option key={p.id} value={p.id}>{p.prefijo}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>N° Nota</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={prefijosNota.find(p => p.id == prefijoAnulacion)?.numero_factura || ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label>Fecha Anulación *</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaAnulacion}
                                                    onChange={(e) => setFechaAnulacion(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Motivo de Anulación</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={motivoAnulacion}
                                            onChange={(e) => setMotivoAnulacion(e.target.value)}
                                            placeholder="Ingrese el motivo de la anulación..."
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalAnulacion(false)}>Cancelar</button>
                                    <button type="button" className="btn btn-danger" onClick={generarNotaAnulacion}>
                                        <i className="fas fa-ban"></i> Generar Nota y Anular
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Debug */}
                {showModalDebug && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-xl modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className={`modal-header ${debugType === 'success' ? 'bg-info' : 'bg-danger'} text-white`}>
                                    <h4 className="modal-title">
                                        {debugType === 'success' ? (
                                            <><i className="fas fa-check-circle mr-2"></i>Envío Exitoso</>
                                        ) : (
                                            <><i className="fas fa-exclamation-triangle mr-2"></i>Error en el Envío</>
                                        )}
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDebug(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    {debugType === 'success' ? (
                                        <div>
                                            <div className="alert alert-info">
                                                <h5><i className="fas fa-check-circle"></i> {debugData?.message}</h5>
                                            </div>
                                            <div className="card border-info">
                                                <div className="card-header bg-info text-white">
                                                    <strong><i className="fas fa-info-circle mr-2"></i>Detalles de la Respuesta</strong>
                                                </div>
                                                <div className="card-body">
                                                    <p><strong>CUFE:</strong> <code style={{fontSize: '0.9em'}}>{debugData?.cufe}</code></p>
                                                    <p><strong>Estado del Documento:</strong> 
                                                        <span className="badge badge-success ml-2">Enviado a DIAN</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="alert alert-danger">
                                                <h5><i className="fas fa-exclamation-triangle"></i> {debugData?.message}</h5>
                                            </div>
                                            
                                            {debugData?.response && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-warning">
                                                        <strong><i className="fas fa-exclamation-triangle mr-2"></i>Respuesta de la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.response, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}
                                            
                                            {debugData?.json_enviado && (
                                                <div className="card mb-3">
                                                    <div className="card-header bg-primary text-white">
                                                        <strong><i className="fas fa-code mr-2"></i>JSON Enviado a la DIAN</strong>
                                                    </div>
                                                    <div className="card-body">
                                                        <pre style={{
                                                            backgroundColor: '#f8f9fa',
                                                            padding: '15px',
                                                            borderRadius: '4px',
                                                            maxHeight: '400px',
                                                            overflow: 'auto',
                                                            fontSize: '12px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordWrap: 'break-word'
                                                        }}>{JSON.stringify(debugData.json_enviado, null, 2)}</pre>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDebug(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Abono */}
                {showModalAbono && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header bg-warning text-white">
                                    <h4 className="modal-title">
                                        <i className="fas fa-coins mr-2"></i>Realizar Abono
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalAbono(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle"></i> Puede realizar abonos parciales desde $1 hasta el saldo pendiente.
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Documento</label>
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            value={documentoAbono ? `${documentoAbono.prefijo}-${documentoAbono.numero}` : ''}
                                            readOnly
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Valor Total</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    value={documentoAbono ? `$${Math.round(parseFloat(documentoAbono.valor_total)).toLocaleString('es-CO')}` : ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Saldo Pendiente</label>
                                                <input 
                                                    type="text" 
                                                    className="form-control text-warning font-weight-bold" 
                                                    value={documentoAbono ? `$${Math.round(getSaldoPendiente(documentoAbono.id)).toLocaleString('es-CO')}` : ''}
                                                    readOnly
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Valor del Abono *</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">$</span>
                                            </div>
                                            <input 
                                                type="number" 
                                                className="form-control" 
                                                placeholder="Ingrese el valor del abono"
                                                value={valorAbono}
                                                onChange={(e) => setValorAbono(e.target.value)}
                                                min="1"
                                                max={documentoAbono ? getSaldoPendiente(documentoAbono.id) : 0}
                                                step="0.01"
                                                required
                                            />
                                        </div>
                                        <small className="form-text text-muted">
                                            Mínimo: $1 - Máximo: ${documentoAbono ? Math.round(getSaldoPendiente(documentoAbono.id)).toLocaleString('es-CO') : 0}
                                        </small>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label>Observaciones</label>
                                        <textarea 
                                            className="form-control" 
                                            rows="3"
                                            value={observacionesAbono}
                                            onChange={(e) => setObservacionesAbono(e.target.value)}
                                            placeholder="Observaciones del abono (opcional)..."
                                        ></textarea>
                                    </div>

                                    {valorAbono && parseFloat(valorAbono) > 0 && (
                                        <div className="alert alert-success">
                                            <strong>Resumen del Abono:</strong><br/>
                                            • Valor a abonar: <strong>${parseFloat(valorAbono).toLocaleString('es-CO')}</strong><br/>
                                            • Saldo después del abono: <strong>${(getSaldoPendiente(documentoAbono?.id || 0) - parseFloat(valorAbono)).toLocaleString('es-CO')}</strong><br/>
                                            • Se generará: <strong>Egreso automático</strong>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalAbono(false)}>
                                        Cancelar
                                    </button>
                                    <button 
                                        type="button" 
                                        className="btn btn-warning" 
                                        onClick={realizarAbono}
                                        disabled={!valorAbono || parseFloat(valorAbono) <= 0}
                                    >
                                        <i className="fas fa-coins"></i> Realizar Abono
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ListadoDocumentosSoporte;
